import { differenceInCalendarDays, parseISO } from 'date-fns';

export const LIFE_CHECK_STALE_DAYS = 14;
export const LIFE_CHECK_RESURFACE_SNOOZE_DAYS = 7;

export function getLifeCheckAgeDays(value: string | null | undefined, now = new Date()) {
  if (!value) {
    return null;
  }

  try {
    return differenceInCalendarDays(now, parseISO(value));
  } catch {
    return null;
  }
}

export function isLifeCheckStale(value: string | null | undefined, now = new Date()) {
  const ageDays = getLifeCheckAgeDays(value, now);
  return ageDays !== null && ageDays >= LIFE_CHECK_STALE_DAYS;
}

export function hasRecentLifeCheckPromptDismissal(value: string | null | undefined, now = new Date()) {
  if (!value || value === '1') {
    return false;
  }

  const ageDays = getLifeCheckAgeDays(value, now);
  return ageDays !== null && ageDays < LIFE_CHECK_RESURFACE_SNOOZE_DAYS;
}

export function createLifeCheckPromptStamp(now = new Date()) {
  return now.toISOString();
}
